import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CoachAthleteStatisticsPage } from "src/pages/CoachAthleteStatisticsPage";
export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/statistics",
)({
  component: CoachAthleteStatisticsPage,
  validateSearch: z.object({
    exercise: z.string().optional(),
    exerciseName: z.string().optional(),
  }),
});
